import { render, staticRenderFns } from "./base-file-picker.component.vue?vue&type=template&id=1331e57f&scoped=true"
import script from "./base-file-picker.component.ts?vue&type=script&lang=ts&external"
export * from "./base-file-picker.component.ts?vue&type=script&lang=ts&external"
import style0 from "./base-file-picker.component.vue?vue&type=style&index=0&id=1331e57f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1331e57f",
  null
  
)

export default component.exports